var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCorporateFareGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_26709",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_26709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 26.25C4.8125 26.25 4.22396 26.0052 3.73438 25.5156C3.24479 25.026 3 24.4375 3 23.75V6.25C3 5.5625 3.24479 4.97396 3.73438 4.48438C4.22396 3.99479 4.8125 3.75 5.5 3.75H13C13.6875 3.75 14.276 3.99479 14.7656 4.48438C15.2552 4.97396 15.5 5.5625 15.5 6.25V8.75H25.5C26.1875 8.75 26.776 8.99479 27.2656 9.48438C27.7552 9.97396 28 10.5625 28 11.25V23.75C28 24.4375 27.7552 25.026 27.2656 25.5156C26.776 26.0052 26.1875 26.25 25.5 26.25H5.5ZM5.5 23.75H13V21.25H5.5V23.75ZM5.5 18.75H13V16.25H5.5V18.75ZM5.5 13.75H13V11.25H5.5V13.75ZM5.5 8.75H13V6.25H5.5V8.75ZM15.5 23.75H25.5V11.25H15.5V23.75ZM19.25 16.25C18.8958 16.25 18.599 16.1302 18.3594 15.8906C18.1198 15.651 18 15.3542 18 15C18 14.6458 18.1198 14.349 18.3594 14.1094C18.599 13.8698 18.8958 13.75 19.25 13.75H21.75C22.1042 13.75 22.401 13.8698 22.6406 14.1094C22.8802 14.349 23 14.6458 23 15C23 15.3542 22.8802 15.651 22.6406 15.8906C22.401 16.1302 22.1042 16.25 21.75 16.25H19.25ZM19.25 21.25C18.8958 21.25 18.599 21.1302 18.3594 20.8906C18.1198 20.651 18 20.3542 18 20C18 19.6458 18.1198 19.349 18.3594 19.1094C18.599 18.8698 18.8958 18.75 19.25 18.75H21.75C22.1042 18.75 22.401 18.8698 22.6406 19.1094C22.8802 19.349 23 19.6458 23 20C23 20.3542 22.8802 20.651 22.6406 20.8906C22.401 21.1302 22.1042 21.25 21.75 21.25H19.25Z",
    fill: "#ADBBCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorporateFareGrey);
export default __webpack_public_path__ + "static/media/icon_corporate_fare_grey.f69ef7ab91016f09b19fda4bd334ab32.svg";
export { ForwardRef as ReactComponent };